<template>
  <div class="create-team">
    <el-form
      v-loading="loading"
      :model="overtimeRuleForm"
      ref="overtimeRuleForm"
      class="white-bg form"
      label-position="left"
      label-width="160px"
      disabled
    >
      <div class="flex flex-v-center flex-h-bet">
        <h2 class="text-gray bold mt-0 mb-40">
          {{ overtimeRuleForm.group_name && overtimeRuleForm.group_name }}
        </h2>
        <div class="btn-wrapper mb-10 mr-20 move-right">
          <router-link
            to="/admin/attendance/overtime/settings/overtime-rules"
            class="btn-back"
          >
            <span> Back</span>
          </router-link>
        </div>
      </div>
      <div class="border">
        <p>Description</p>
        <p class="bold mt-20">
          {{ overtimeRuleForm.description && overtimeRuleForm.description }}
        </p>

        <el-form-item
          label="Do you want to tie this overtime rules to your workshift ?"
          label-width="400px"
          class="mt-20"
          prop="use_work_shift"
        >
          <el-radio-group
            v-model="overtimeRuleForm.use_work_shift"
            class="mt-10"
          >
            <el-radio :label="true">Yes</el-radio>
            <el-radio :label="false">No</el-radio>
          </el-radio-group>
        </el-form-item>
      </div>
      <div class="mt-20 border">
        <h4 class="text-gray bold mt-20 mb-40">Overtime Rules</h4>
        <el-form-item
          label="Overtime starts"
          class="mt-20"
          prop="overtime_start"
        >
          <el-input
            v-model="overtimeRuleForm.overtime_start"
            class="inline-input"
          ></el-input>
          <span class="ml-10">
            <span class="bold">minutes</span> after workhours ends</span
          >
        </el-form-item>
        <el-form-item label="Overtime ends" class="mt-20" prop="overtime_end">
          <el-input
            v-model="overtimeRuleForm.overtime_end"
            class="inline-input"
          ></el-input>
          <span class="ml-10">
            <span class="bold">minutes</span> after workhours ends</span
          >
        </el-form-item>

        <el-form-item label="Round up" class="mt-20" prop="overtime_round_up">
          <el-input
            v-model="overtimeRuleForm.overtime_round_up"
            class="inline-input"
          ></el-input>
          <span class="ml-10">
            <span class="bold">minutes</span> to 1 hour</span
          >
        </el-form-item>
      </div>

      <div class="mt-20 border">
        <h4 class="text-gray bold mt-20 mb-40">Workday Rules</h4>
        <div v-if="!overtimeRuleForm.use_work_shift">
          <div class="inline-flex">
            <el-form-item
              label="Apply when"
              label-width="100px"
              prop="work_type"
            >
              <el-select
                v-model="overtimeRuleForm.work_type"
                placeholder=""
                class="inline-select"
              >
                <el-option
                  v-for="item in workOption"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
              <span class="ml-10"> is greater than </span>
            </el-form-item>
            <el-form-item label-width="0" prop="work_time">
              <el-time-picker
                v-model="overtimeRuleForm.work_time"
                class="inline-time"
                value-format="HH:mm:ss"
              >
              </el-time-picker
            ></el-form-item>
          </div>
          <el-form-item
            class="mt-20"
            label="Select Workdays"
            prop="work_day_ids"
          >
            <el-checkbox-group v-model="overtimeRuleForm.work_day_ids">
              <el-checkbox label="1">Monday</el-checkbox>
              <el-checkbox label="2">Tuesday</el-checkbox>
              <el-checkbox label="3">Wednesday</el-checkbox>
              <el-checkbox label="4">Thursday</el-checkbox>
              <el-checkbox label="5">Friday</el-checkbox>
              <el-checkbox label="6">Saturday</el-checkbox>
              <el-checkbox label="7">Sunday</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </div>

        <el-form-item label-width="0" prop="apply_overtime_on_work_day">
          <el-checkbox v-model="overtimeRuleForm.apply_overtime_on_work_day"
            >Apply overtime rates when employees work on workdays they weren’t
            suppose to work</el-checkbox
          >
        </el-form-item>
      </div>

      <div class="mt-20 border">
        <h4 class="text-gray bold mt-20 mb-40">Non-Workday Rules</h4>
        <el-form-item
          label-width="0"
          class="mt-20"
          prop="apply_overtime_on_non_work_day"
        >
          <el-checkbox v-model="overtimeRuleForm.apply_overtime_on_non_work_day"
            >Apply overtime rates when employees work on their
            non-workdays</el-checkbox
          >
        </el-form-item>
      </div>

      <div class="mt-20 border">
        <h4 class="text-gray bold mt-20 mb-40">Public Holidays</h4>
        <el-form-item label-width="0" class="mt-20" prop="public_holiday">
          <el-checkbox v-model="overtimeRuleForm.public_holiday"
            >Treat public holidays as a workday</el-checkbox
          >
        </el-form-item>
      </div>

      <div class="mt-20">
        <h4 class="text-gray bold mt-20 mb-40">Overtime Rate Calculation</h4>
        <el-form-item
          class="mt-20"
          label="I want to use"
          label-width="120px"
          prop="payment_type"
        >
          <el-radio-group v-model="overtimeRuleForm.payment_type" class="mt-10">
            <el-radio :label="true">A fixed rate</el-radio>
            <el-radio :label="false">A percentage</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          v-if="overtimeRuleForm.payment_type"
          class="mt-20"
          label="Overtime Rate Per Hour"
          label-width="200px"
          prop="fixed_amount"
        >
          <el-input
            placeholder="Enter rate"
            v-model="overtimeRuleForm.fixed_amount"
            @keypress.native="onlyNumbers"
            class="inline-input"
          ></el-input>
        </el-form-item>
        <div class="flex" v-if="!overtimeRuleForm.payment_type">
          <el-form-item
            label="Overtime Rate Per Hour"
            label-width="200px"
            prop="percentage_value"
          >
            <el-input
              class="small"
              placeholder="100"
              v-model="overtimeRuleForm.percentage_value"
              @keypress.native="onlyNumbers"
            >
              <template slot="append">{{ "%" }}</template>
            </el-input>
          </el-form-item>
          <div class="ml-10 mt-10 small">of employee’s work rate per hour</div>
        </div>
      </div>
    </el-form>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapActions } = createNamespacedHelpers("admin/attendance/overtime");
import { capitalize } from "@/helpers/functions";

export default {
  data() {
    return {
      loading: false,
      overtimeRuleForm: {
        group_name: "",
        description: "",
        use_work_shift: true,
        overtime_start: null,
        overtime_end: null,
        overtime_round_up: null,
        work_type: "WORKDAY",
        work_time: "",
        work_day_ids: [],
        apply_overtime_on_work_day: false,
        apply_overtime_on_non_work_day: false,
        public_holiday: false,
        payment_type: true,
        fixed_amount: null,
        percentage_value: null,
      },
      workOption: [
        { label: "Workday", value: "WORKDAY" },
        { label: "Work-week", value: "WORKWEEK" },
      ],
    };
  },
  mounted() {
    const id = this.$route.params.id;
    if (id) {
      this.fetchOvertimeRule(id);
    }
  },
  methods: {
    capitalize,
    ...mapActions(["getRuleById"]),
    fetchOvertimeRule(id) {
      this.loading = true;
      this.$store
        .dispatch("admin/attendance/overtime/getRuleById", id)
        .then(response => {
          this.loading = false;
          const {
            group_name,
            description,
            use_work_shift,
            overtime_start,
            overtime_end,
            overtime_round_up,
            work_type,
            work_time,
            work_day_ids,
            apply_overtime_on_work_day,
            apply_overtime_on_non_work_day,
            public_holiday,
            payment_type,
            fixed_amount,
            percentage_value,
          } = response.data;

          this.overtimeRuleForm = {
            ...this.overtimeRuleForm,
            group_name,
            description,
            use_work_shift: use_work_shift === 0 ? false : true,
            overtime_start,
            overtime_end,
            overtime_round_up,
            work_type,
            work_time,
            work_day_ids: work_day_ids.map(String),
            apply_overtime_on_work_day:
              apply_overtime_on_work_day === 0 ? false : true,
            apply_overtime_on_non_work_day:
              apply_overtime_on_non_work_day === 0 ? false : true,
            public_holiday: public_holiday === 0 ? false : true,
            payment_type: payment_type === "FIXED" ? true : false,
            fixed_amount,
            percentage_value,
          };
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style scoped>
.el-select.inline-select {
  width: 50% !important;
}
.el-input.inline-input {
  width: 20% !important;
}
.el-time-picker.inline-time {
  width: 20% !important;
}
.input-with-select .el-input-group__append {
  width: 10px !important;
}
</style>
